import { Input, Typography } from 'antd';

import styled from '@emotion/styled';

const { Paragraph, Title } = Typography;

export const Heading = styled(Title)`
  && {
    margin-bottom: 0;
  }
`;

/** A drawer section label: the paragraph sits tight against the control it introduces. */
export const SectionLabel = styled(Paragraph)`
  && {
    margin-bottom: 4px;
  }
`;

/** The same, where a sentence of explanation follows before the control. */
export const SectionNote = styled(Paragraph)`
  && {
    margin-bottom: 8px;
  }
`;

/** Reasons a person got no account. Flush left inside the alert that frames it. */
export const ReasonList = styled.ul`
  margin: 0;
  padding-left: 18px;
  /* Keycloak's answers arrive verbatim and can be one 300-character token with no space in it —
     a JSON body, or a URL. Without this the line runs past the 720px drawer instead of wrapping. */
  overflow-wrap: anywhere;
`;

export const SearchInput = styled(Input.Search)`
  && {
    width: 320px;
  }
`;

/**
 * Wraps the queue table. Rows are clickable as a shortcut — the keyboard-reachable way in is the
 * Open button in the trailing column — so the cursor hint belongs here rather than in a per-row
 * inline style. A wrapper rather than `styled(Table)`, which is how the other tables in this app do
 * it: Ant Design's Table is generic, and styling it directly loses the row type.
 */
export const QueueContainer = styled.div`
  .ui-table-tbody > tr {
    cursor: pointer;
  }
`;

/**
 * The empty-table message that explains a disabled action.
 *
 * Ant Design renders `locale.emptyText` in its muted secondary colour, which is right for "no rows
 * yet" and wrong here: this text is the reason the primary button will not work, and it was reading
 * as decoration next to it. Black and bold, so the sentence carries the weight of what it says.
 */
export const BlockingEmptyText = styled.div`
  && {
    color: ${({ theme }) => theme.colors.black};
    font-weight: 600;
  }
`;
